import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-splash',
  templateUrl: 'splash.html',
})
export class Splash {

  client: any;

  constructor(public navCtrl: NavController, public params: NavParams) {
    this.client = this.params.get('client');
  }

}
// end file



// WEBPACK FOOTER //
// ./src/pages/splash/splash.ts